import React, { useState } from "react";

import "./HideableBox.css";
import DivButton from "./DivButton";
export default function HideableBox(props) {
  const hiddenByDefault =
    props.hiddenByDefault === undefined ? true : props.hiddenByDefault;
  const ClassList = props.ClassList === undefined ? "" : props.ClassList;
  const [Hidden, setHidden] = useState(hiddenByDefault);

  function toggleHide(e) {
    e.stopPropagation();
    setHidden(!Hidden);
  }
  const action = props.label.includes("Edit") ? "" : "Show";
  return (
    <div className={Hidden ? ClassList : "HideableContainer " + ClassList}>
      {Hidden ? <></> : <div>{props.children}</div>}
      <DivButton onClick={(e) => toggleHide(e)}>
        {Hidden ? action : "Hide"} {props.label}
      </DivButton>
    </div>
  );
}
